import React from 'react'
import PropTypes from 'prop-types'
import { StyledH2 } from './styles'

const TitleProject = ({name}) => {
  return (
    <StyledH2
      data-testid='element-title'
    >
      {name}
    </StyledH2>
  )
}

TitleProject.propTypes = {
  name: PropTypes.string.isRequired,
}

export default TitleProject
